import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { addStoryRoute } from "../../routes/routesPath";
import { privateListingFilters } from "../../utils/filters";
import { getFilters } from "../../utils/helpers";
import { defaultPage, limitOptions, sortingOptions } from "../../utils/constants";
import { isArray } from "../../utils/formatersAndParsers";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getPrivateStoriesList } from "../../redux/stories/thunk";
import AskToShare from "../../Component/askToShare";
import MySelect from "../../Component/common/mySelect";
import MyPagination from "../../Component/common/pagination";
import StoryCard from "../../Component/storyCard/myStoryCard";
import ReactionsListsPop from "../../Component/Modals/reactionsListPop";
import LoadIndicator from "../../Component/Loader";
import CardSkeleton from "../../Component/skeleton/cardSkeleton";
import FeelingsFilter from "../../Component/common/filters/feelingsFilter";
import SortingDropdown from "../../Component/common/filters/sortingDropdown";
import MyHelmet from "../../seo/helmet";

export default function PrivateDirectory() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedFilters = Object.fromEntries(searchParams.entries());

  const { privateStoriesList = {}, loadingPrivateStories = false } = useSelector(
    (state) => state.stories || {}
  );

  const [userAction, setUserAction] = useState(null);
  const [paginationDetails, setPaginationDetails] = useState(defaultPage);

  const handleLimit = (selected) => {
    setPaginationDetails((prev) => ({ ...prev, limit: selected }));
    setSearchParams(
      (prev) => {
        prev.set("limit", selected);
        return prev;
      },
      { replace: true }
    );
  };

  const handleStories = async () => {
    const filters = await getFilters(privateListingFilters, selectedFilters);

    await handleApiRequest(getPrivateStoriesList, filters);
  };

  useEffect(() => {
    handleStories();
  }, [searchParams]);

  return (
    <>
      <MyHelmet
        title={"Private directory | Check stories saved private to you"}
        keywords=""
        description=""
      />

      <div className="w-100 overflow-auto">
        {privateStoriesList.totalCount > 0 && (
          <div
            className={`${
              loadingPrivateStories ? "" : "hide-loader"
            } d-flex align-items-center justify-content-center`}>
            <LoadIndicator />
          </div>
        )}
        <div className="storyFilters d-flex align-items-center gap-2 p-3 px-lg-5">
          <SortingDropdown sortingOptions={sortingOptions.slice(1)} />
          <FeelingsFilter />
        </div>
        {privateStoriesList.totalCount === 0 ? (
          <div className="text-center my-4">
            <h3 className="m-0">FeelingHub is just for you...</h3>
            <img src="/images/noPrivateStory.png" className="max-w-400 w-100" />
            <h4 className="text-uppercase m-0">Write your memories and experience</h4>
            <p className="">Anything you save here will be visible to you only</p>
            <button
              className="primaryBtn rounded px-3 py-2"
              onClick={() => navigate(addStoryRoute)}>
              Write for yourself
            </button>
          </div>
        ) : (
          <>
            <div className={`px-2 px-lg-3 pt-3`}>
              {isArray(privateStoriesList.records).length > 0
                ? privateStoriesList.records?.map((story, i) => (
                    <StoryCard
                      key={story._id}
                      story={story}
                      handleReactionsList={setUserAction}
                      storyType="private"
                    />
                  ))
                : Array.from({ length: 4 }).map((_, i) => <CardSkeleton key={i} />)}
              <div className="d-flex justify-content-between py-3">
                <div>
                  <MySelect
                    classNamePrefix={"mySelect"}
                    options={limitOptions}
                    isSearchable={false}
                    value={paginationDetails.limit}
                    onChange={handleLimit}
                  />
                </div>
                <MyPagination
                  paginationDetails={paginationDetails}
                  setPaginationDetails={setPaginationDetails}
                  totalCount={privateStoriesList.totalCount}
                  darkPagination={true}
                />
              </div>
            </div>
          </>
        )}

        <div className="curvatureContainer">
          <div>
            <div id="curved-corner-topright" />
          </div>
          <div>
            <div id="curved-corner-topleft" />
          </div>
        </div>

        <AskToShare />
      </div>
      {userAction?.action === "showReactionsList" && (
        <ReactionsListsPop userAction={userAction} setUserAction={setUserAction} />
      )}
    </>
  );
}
